import React from 'react';
import { Box } from '@mui/material';
import ConsultaChat from '../components/Consultas/ConsultaChat';
import { useApi } from '../hooks/useApi';

const ConsultasPage: React.FC = () => {
    const api = useApi();

    const handleConsulta = async (consulta: any) => {
        try {
            console.log('Enviando consulta:', consulta);
            const response = await api.post('/api/Consultas/analizar', consulta);
            console.log('Respuesta recibida:', response.data);
            return response.data.respuesta;
        } catch (error: any) {
            console.error('Error completo:', error);
            if (error.response) {
                console.error('Datos del error:', error.response.data);
                throw new Error(error.response.data.error || 'Error al procesar la consulta');
            }
            throw error;
        }
    };

    return (
        <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh', p: { xs: 2, sm: 3 } }}>
            <ConsultaChat onConsulta={handleConsulta} />
        </Box>
    );
};

export default ConsultasPage; 